import { Component, input } from '@angular/core'

@Component({
  template: `
    <div [attr.uid]="api()?.uid">
      <span [tmd]="api()?.message || ''"></span>
    </div>
  `,
  standalone: false,
})
export class AlertComponent {
  api = input<{
    message?: string
    uid?: string
  }>()
}
